import styled from 'styled-components'

import { BaseBadgeStyles, type IBaseBadgeProps } from './BaseBadgeStyles'
import { type StatusBadgeStatus } from '../StatusBadge'
import { IconStyled } from '@ui/elements/Icon'
import { IconComponentStyled } from '@ui/elements/Icon/styles/IconComponentStyled'

interface IStatusBadgeStyledProps extends IBaseBadgeProps {
  type: StatusBadgeStatus
}

export const StatusBadgeStyled = styled.span<IStatusBadgeStyledProps>`
  ${BaseBadgeStyles}

  color: ${(props) => props.theme.colors.badge[props.type].content};

  background: ${(props) => props.theme.colors.badge[props.type].background};

  > ${IconStyled}, > ${IconComponentStyled} {
    transform: scale(0.75);
    margin-right: ${(props) => props.theme.typography.pxToRem(4)};
  }
`
